import e from "../../../utils/debounce/index.js";

const t = (e, {exact: s, path: i, children: c}) => !!(s ? i === e : e.startsWith(i)) || !!c?.some((s => t(e, s)));

class s {
    ref;
    depth;
    active=!1;
    constructor(e, t) {
        this.ref = e, this.depth = t;
    }
    setActive(e) {
        this.active = t(window.location.pathname, e);
    }
}

class i {
    elementsByItem=new Map;
    subscribers=[];
    path="";
    Link;
    activeElement=null;
    constructor(e) {
        this.Link = e, this.updatePath();
    }
    callSubscribers() {
        this.subscribers.forEach((e => e()));
    }
    updateActiveState() {
        for (const [e, t] of this.elementsByItem) t.setActive(e);
    }
    isActive(e) {
        return !!this.elementsByItem.get(e)?.active;
    }
    updateActiveElement=e((() => {
        let e = null;
        for (const t of this.elementsByItem.values()) if (t.active && 0 === t.depth) {
            e = t.ref;
            break;
        }
        e !== this.activeElement && (this.activeElement = e, this.callSubscribers());
    }), 80);
    updatePath() {
        const e = window.location.pathname;
        this.path !== e && (this.path = e, this.updateActiveState(), this.callSubscribers(), 
        this.updateActiveElement());
    }
    el(e, t, i) {
        if (i) {
            const c = new s(i, t);
            this.elementsByItem.set(e, c), c.setActive(e);
        } else this.elementsByItem.delete(e);
        this.callSubscribers(), this.updateActiveElement();
    }
    subscribe=e => (this.subscribers.push(e), () => this.subscribers.splice(this.subscribers.indexOf(e), 1));
    destroy() {
        this.updateActiveElement.cancel();
    }
}

export { i as default };
//# sourceMappingURL=index.js.map
